import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import SET_SELLER from './types';
export default _defineProperty({}, SET_SELLER, function (state, payload) {
  var currentState = state;
  currentState.seller = payload;
});